export const ON_SUBMIT: 'onSubmit' = 'onSubmit' as const
export const ON_CHANGE: 'onChange' = 'onChange' as const
export const ON_ALL: 'all' = 'all' as const
export const ON_BLUR: 'onBlur' = 'onBlur' as const
export const ON_TOUCHED: 'onTouched' = 'onTouched' as const
